import { FormControl, TextField } from "@mui/material";
import { styled } from "@mui/system";

export const StyledFormControl = styled(FormControl, {
  shouldForwardProp: prop => prop !== "className"
})({
  width: "100%",
  display: "flex",
  ".iePlaceholder": {
    position: "absolute",
    color: "#86868b",
    top: "16px",
    left: "16px",
    backgroundColor: "transparent",
    opacity: "0.42",
    letterSpacing: "-0.7px"
  },
  "& .warningContainer": {
    fontSize: "12px",
    color: "#ea991d",
    margin: 0,
    marginTop: "10px"
  }
});

export const StyledTextField = styled(TextField)(({ theme }) => {
  const light = theme.palette.type === "light";
  const placeholder = {
    color: "#86868b",
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.shorter
    })
  };
  const placeholderHidden = {
    opacity: "0 !important"
  };
  const placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    "& .MuiFilledInput-root": {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: "0.08px",
      color: "#2C2C2C",
      backgroundColor: "#FFF",
      borderRadius: "10px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#BCBDC0",
      "&.warning": {
        borderColor: "#ea991d"
      },
      "&:hover": {
        backgroundColor: "#FFF"
      },
      "&.Mui-focused": {
        backgroundColor: "#FFF"
      },
      "&.Mui-disabled": {
        backgroundColor: "#F2F2F2"
      },
      "&.Mui-error": {
        borderColor: "#ea2b1e"
      },
      "&:focus-within": {
        borderColor: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
      },
      textarea: {
        padding: "0px 5px",
        borderRadius: 0
      }
    },
    "& .MuiFilledInput-input": {
      paddingLeft: 16,
      paddingRight: 16,
      borderRadius: "10px",
      border: "none",
      height: "22px",
      "&::placeholder": placeholder,
      "&::-webkit-input-placeholder": placeholder,
      "&::-moz-placeholder": placeholder,
      "&:-ms-input-placeholder": placeholder,
      "&::-ms-input-placeholder": placeholder,
      "label[data-shrink=false] + .MuiInputBase-formControl &": {
        "&::-webkit-input-placeholder": placeholderHidden,
        "&::-moz-placeholder": placeholderHidden,
        "&:-ms-input-placeholder": placeholderHidden,
        "&::-ms-input-placeholder": placeholderHidden,
        "&:focus::-webkit-input-placeholder": placeholderVisible,
        "&:focus::-moz-placeholder": placeholderVisible,
        "&:focus:-ms-input-placeholder": placeholderVisible,
        "&:focus::-ms-input-placeholder": placeholderVisible
      }
    },
    "& .MuiInputLabel-filled": {
      color: "#585A61",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: "0.08px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      transform: "translate(16px, 18.5px) scale(1)"
    },
    "& .MuiInputLabel-shrink": {
      fontWeight: 500,
      fontSize: "0.875rem",
      transform: "translate(16px, 10px) scale(0.75)"
    }
  };
});

export const StyledInputGroup = styled("div")(({ theme }) => ({
  "& .selectCombined": {
    position: "relative",
    "& > div": {
      width: "auto",
      margin: "0 !important"
    },
    "& div::after": {
      opacity: 0
    },
    "& > div:first-of-type": {
      width: "100px",
      position: "absolute",
      zIndex: 1,
      "& fieldset": {
        borderColor: "transparent",
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0"
      },
      "& label": {
        maxWidth: "unset"
      },
      "& svg": {
        right: "10px"
      },
      "& input": {
        paddingLeft: 0
      },
      "& legend": {
        marginLeft: 0
      },
      "& .MuiSelect-select.Mui-disabled": {
        backgroundColor: "transparent",
        fontSize: "1rem"
      }
    },
    "& > div:last-child": {
      flex: 1,
      position: "relative",
      "& label": {
        transform: "translate(110px, 20px) scale(1)"
      },
      "& label.MuiInputLabel-filled.MuiInputLabel-shrink": {
        transform: "translate(110px, 10px) scale(0.75)"
      },
      "& label.MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(110px, -6px) scale(0.75)"
      },
      "& legend": {
        marginLeft: 95
      },
      "& input": {
        paddingLeft: "110px"
      },
      "& mark": {
        left: "106px"
      }
    }
  }
}));
